import { z } from 'zod';

// Adapted from https://github.com/astahmer/openapi-zod-client/blob/main/examples/export-schemas-and-types-directly/schemas-and-types-directly.hbs

const Id = z.string();
const DriverStatus = z.string();
const Email = z.string();
const DriverResponse = z
    .object({
        id: Id.uuid(),
        account_id: Id.uuid(),
        status: DriverStatus.optional(),
        email: Email.max(255).email().optional(),
        first_name: z.string().max(255).optional(),
        last_name: z.string().max(255).optional(),
        display_name: z.string().optional(),
        phone_number: z.string().max(255).optional(),
        subject: z.string().optional(),
    })
    .passthrough();
const IdentificationType = z.string();
const Identification = z
    .object({
        id: Id.uuid(),
        identification_type: IdentificationType,
        identification: z.string(),
    })
    .passthrough();
const Tag = z.object({ id: Id.uuid() }).passthrough();
const DriverEmbedded = DriverResponse.and(
    z
        .object({
            _embedded: z
                .object({
                    identifications: z.array(Identification),
                    tags: z.array(Tag),
                })
                .partial()
                .passthrough(),
        })
        .partial()
        .passthrough()
);
const Link = z.object({ href: z.string() }).passthrough();
const PaginationLinks = z.object({ self: Link, next: Link.optional() }).passthrough();
const DriversEmbeddedList = z.object({ items: z.array(DriverEmbedded), _links: PaginationLinks }).passthrough();
const DriverRequest = z
    .object({
        id: Id.uuid(),
        account_id: Id.uuid(),
        status: DriverStatus.optional(),
        email: Email.max(255).email().optional(),
        first_name: z.string().max(255).optional(),
        last_name: z.string().min(1).max(255),
        phone_number: z.string().max(255).optional(),
        subject: z.string().optional(),
    })
    .passthrough();
const IdentificationList = z.object({ items: z.array(Identification) }).passthrough();
const TagList = z.object({ items: z.array(Tag) }).passthrough();

export const schemas = {
    Id,
    DriverStatus,
    Email,
    DriverResponse,
    IdentificationType,
    Identification,
    Tag,
    DriverEmbedded,
    Link,
    PaginationLinks,
    DriversEmbeddedList,
    DriverRequest,
    IdentificationList,
    TagList,
};
